import { render, staticRenderFns } from "./ClauseDialog.vue?vue&type=template&id=1c5fb905&"
import script from "./ClauseDialog.vue?vue&type=script&lang=js&"
export * from "./ClauseDialog.vue?vue&type=script&lang=js&"
import style0 from "./ClauseDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClauseDialog.vue"
export default component.exports